export const fieldLabel = key => key.replace(/\.record_[^.]+\./, '.').split('.').map(part => (['crm','ai'].includes(part)?part.toUpperCase():part.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase()))).join(' · ');
export const hasValue = value => value !== null && value !== undefined && String(value).trim() !== '';
export function slashQuery(text, caret) {
  const match = text.slice(0, caret).match(/(?:^|[\s(])\/([\w .-]{0,60})$/);
  return match ? { start: caret - match[1].length - 1, end: caret, query: match[1] } : null;
}
export function matchingFields(values, query = '') {
  const words = query.toLowerCase().trim().split(/\s+/);
  return Object.entries(values).filter(([key]) => words.every(word => fieldLabel(key).toLowerCase().includes(word) || key.toLowerCase().includes(word)))
    .sort(([a,av],[b,bv]) => Number(hasValue(bv))-Number(hasValue(av)) || a.localeCompare(b));
}
export function resolveBindings(values, bindings) {
  return {...values, ...Object.fromEntries(Object.entries(bindings).map(([key, source]) => [key, values[source] ?? '']))};
}
